import * as React from "react"

import { cn } from "@/lib/utils"

// Fase 1 UI Pro Max: card por defecto es "quieta" (no reacciona) para no
// romper diseños existentes. Para hover atlético con translateY + glow,
// usar la variante <Card interactive> o la clase `.card-default` del CSS.
const Card = React.forwardRef(({ className, interactive = false, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "rounded-lg border border-zinc-700 bg-card text-card-foreground shadow-[inset_0_1px_0_rgba(229,233,240,.04),0_1px_2px_rgba(0,0,0,.45)]",
      "transition-[border-color,transform,box-shadow] duration-normal ease-out-atl",
      interactive && [
        "cursor-pointer",
        "hover:-translate-y-0.5 hover:shadow-card-hover",
        "hover:border-primary/40",
        "active:translate-y-0 active:scale-[0.99]",
      ],
      className
    )}
    {...props} />
))
Card.displayName = "Card"

const CardHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex flex-col space-y-1.5 p-6", className)}
    {...props} />
))
CardHeader.displayName = "CardHeader"

const CardTitle = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("font-display font-bold leading-none tracking-tight", className)}
    {...props} />
))
CardTitle.displayName = "CardTitle"

const CardDescription = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("text-sm text-muted-foreground", className)}
    {...props} />
))
CardDescription.displayName = "CardDescription"

const CardContent = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("p-6 pt-0", className)} {...props} />
))
CardContent.displayName = "CardContent"

const CardFooter = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex items-center p-6 pt-0", className)}
    {...props} />
))
CardFooter.displayName = "CardFooter"

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent }
